"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = LoadingEllipses;
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const mui_1 = require("tss-react/mui");
const tss_react_1 = require("tss-react");
const useStyles = (0, mui_1.makeStyles)()({
    dots: {
        '&::after': {
            display: 'inline-block',
            content: '""',
            width: '1em',
            textAlign: 'left',
            animation: `${(0, tss_react_1.keyframes) `
      0% {
        content: '';
      }
      25% {
          content: '.';
      }
      50% {
        content: '..';
      }
      75% {
        content: '...';
      }
      `} 1.2s infinite ease-in-out`,
        },
    },
});
function LoadingEllipses({ message, variant = 'body2', ...rest }) {
    const { classes } = useStyles();
    return (react_1.default.createElement(material_1.Typography, { className: classes.dots, ...rest, variant: variant }, `${message || 'Loading'}`));
}
